import Card from "../components/Card";
import Image from "../components/Image";

function StatsMiddle() {
  return (
    <>
      <div
        className=" w-[59%] h-full"
        style={{ transformStyle: "preserve-3d" }}
      >
        <Card
          borderRadius="rounded-2xl"
          innerContent={
            <Image
              containerCss={"w-full h-full"}
              imgCss={"w-full h-full object-fit"}
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1648300135/passage/passage-showcase/submit_weekly-min_mjivqs.png"
              }
            />
          }
        />
      </div>
      <div
        className=" w-[40%] h-full"
        style={{ transformStyle: "preserve-3d" }}
      >
        <Card
          borderRadius="rounded-2xl"
          innerContent={
            <Image
              containerCss={"w-full h-full"}
              imgCss={"w-full h-full object-contain"}
              src={
                "https://res.cloudinary.com/dl5mqatis/image/upload/v1648300135/passage/passage-showcase/ship_detected-min_y4hlxo.png"
              }
            />
          }
        />
      </div>
    </>
  );
}

export default StatsMiddle;
